import React, { useState } from 'react';
import Logo from "../assets/idea centered inquiry_logo.png";
import { HiOutlineBars3 } from 'react-icons/hi2';
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import LoginIcon from "@mui/icons-material/Login"; 
import PersonAddIcon from "@mui/icons-material/PersonAdd"; 

import { List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Drawer, Button } from "@mui/material"
import { Box } from '@mui/system';
import { Register } from './Register';
import { Login } from './Login'

export default function Navbar() {
  const [openMenu, setOpenMenu] = useState(false)
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const menuOptions = [
    {
      text: "首頁",
      icon: <HomeIcon />,
    },
    {
      text: "關於",
      icon: <InfoIcon />,
    },
    {
      text: "登入",
      icon: <LoginIcon />,
      action: () => {
        setOpenMenu(false); 
        setOpenLogin(true); 
      },
    },
    {
      text: "註冊",
      icon: <PersonAddIcon />,
      action: () => {
        setOpenMenu(false); 
        setOpenRegister(true); 
      },
    },
  ];
  return (
    <nav>
       <div className='nav-logo-container'>
        <img alt='' src={Logo} width={250} height={250} />
      </div>

      <div className="navbar-links-container" style={{ marginLeft: "auto" }}>
        <a href=''>首頁</a>
        <a href=''>關於</a>
        <button className='login-button' onClick={() => setOpenLogin(true)}>登入</button>
      <button className='register-button' onClick={() => setOpenRegister(true)}>註冊</button>

   </div>

      <div className='navbar-menu-container' style={{ marginLeft: "auto" }}>
        <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
      </div>
      <Drawer 
        open={openMenu} 
        onClose={() => setOpenMenu(false)} 
        anchor='right'
        variant="temporary"
        hideBackdrop={true}
        ModalProps={{
          disableScrollLock: true,
        }}
        sx={{
          '& .MuiDrawer-paper': {
            width: '250px', // 固定寬度，不會佔滿畫面
            maxWidth: '80vw', // 手機上最多佔 80% 寬度
          }
        }}
        PaperProps={{
          sx: {
            width: '250px', // 固定寬度
            maxWidth: '80vw', // 手機上最多佔 80% 寬度
          }
        }}
      >
        <Box sx={{ width: '100%', maxWidth: '250px' }} role="presentation">
          <List>
            {menuOptions.map((item, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton 
                  onClick={() => {
                    if (item.action) {
                      item.action();
                    }
                  }}
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    }
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
      <Login open={openLogin} setOpen={setOpenLogin} setOpenRegister={setOpenRegister} />
      <Register open={openRegister} setOpen={setOpenRegister} setOpenLogin={setOpenLogin} />
     </nav>
  )
}